import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import Lenis from "lenis";

gsap.registerPlugin(ScrollTrigger);

let lenis = null;
let tickerFn = null;

// Starts (or reuses) the singleton Lenis instance and syncs it with GSAP's
// ticker so ScrollTrigger stays frame-accurate under smooth-scroll inertia.
export const startSmoothScroll = () => {
  if (lenis) return lenis;

  lenis = new Lenis({
    duration: 1.1,
    smoothWheel: true,
  });

  lenis.on("scroll", ScrollTrigger.update);

  tickerFn = (time) => lenis.raf(time * 1000);
  gsap.ticker.add(tickerFn);
  gsap.ticker.lagSmoothing(0);

  return lenis;
};

export const stopSmoothScroll = () => {
  if (tickerFn) gsap.ticker.remove(tickerFn);
  if (lenis) lenis.destroy();
  lenis = null;
  tickerFn = null;
};

export const getLenis = () => lenis;

// Smoothly scrolls to a section, accounting for the sticky navbar height.
export const scrollToSection = (target, offset = -60) => {
  if (lenis) {
    lenis.scrollTo(target, { offset });
  } else {
    const el = typeof target === "string" ? document.querySelector(target) : target;
    el?.scrollIntoView({ behavior: "smooth" });
  }
};
